export const prebuiltPrompts = [
	{
		id: 0,
		name: "Urban Oasis",
		prompt:
			"photo of an beautiful sunny day environment concexpt art on a cliff, architecture by kengo kuma, ian hubert and wes anderson with village, residential area, mixed development, highrise made up staircases, balconies, full of glass facades, cgsociety, fantastic realism, volumetric light, hyperdetailed, artstation hq",
		negative_prompt: "",
	},
	{
		id: 1,
		name: "Steampunk Knight",
		prompt: "an old ateampunk knight, very long bread, looking at camera, dark and foggy woods, detailed face, detailed perfect eyes, wideangle lens, f1.8",
		negative_prompt:
			"art, anime, cartoon, deformed, bad anatomy, disfigured, poorly drawn face, mutation, extra limb, ugly, disgusting, poorly drawn face, missing limb, floating limb, disconected limbs, malformed hands, blurry, (((mutated hands and fingers))), watermark, watermarked, censored, oversaturated, amputation, obese, double face, double hands, double body, extra digit, fewer digits, signature, frowning eyebrows, sad, deformed thighs",
	},
	{
		id: 2,
		name: "Cyberpunk Portrait",
		prompt:
			"Transport viewers to a rain-soaked dystopian future with an exquisitely detailed portrait of a young woman adorned in cyberpunk attire, the atmospheric Blade Runner surroundings. Employ expert photographic lighting techniques to capture the realism of her features, bringing this composition to life in stunning 10k resolution",
		negative_prompt:
			"Asian-Less-Neg bad-artist bad-artist-anime bad-hands-5 bad_pictures bad_prompt_version2 badhandv4 By bad artist -neg CyberRealistic_Negative-neg EasyNegative negative_hand-neg ng_deepnegative_v1_75t verybadimagenegative_v1.3, lowres, text, error, cropped, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, out of frame, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck, username, watermark, signature",
	},
	{
		id: 3,
		name: "Cinematic Landscape",
		prompt:
			"nature landscape, aerial view, drone photography, cinematic, mountains and ocean, cinematic view, epic sky, detailed, concept art, high detail, warm lighting, volumetric, godrays, vivid, beautiful, trending on artstation, by jordan grimmer, art greg rutkowski",
		negative_prompt: "",
	},
	{
		id: 4,
		name: "Fairy Princess",
		prompt:
			"highly detailed ilustration of a beautiful white haired woman as a fairy princess in a garden holding a bunch of wild flowers, deep focus, d & d, fantasy, intricate, elegant, highly detailed, digital painting, artstation, concept art, matte, sharp focus, illustration, hearthstone, art by artgerm and greg rutkowski and alphonse mucha",
		negative_prompt: "",
	},
	{
		id: 5,
		name: "Epic Armour Portrait",
		prompt:
			"professional digital art of a hyper realistic and highly detailed beautiful woman in a beautiful complex attractive armor. girl's face is hyper realistic, symetric, and highly detailed. head and shoulders view. background is an ancient temple, knights of zodiac style. greg rutkowski, zabrocki, karlkka, jayison devadas, intricate, trending on artstation, 8 k, unreal engine 5",
		negative_prompt: "",
	},
];
